module.exports = "https://static.wmbcdn.com/uniweb/images/ec2d79fd2b696d3ee0ac07af453e463e.svg";